import React from 'react';
import {HomeGameCardItem, HomeGameFloorItem} from '../home.type';
import HomeCategory from '@/components/business/home-category/home-category';
import {goTo} from '@/utils';
// import {GameCard} from './game-card';
import RenderGameCardSection from './game-section-2';
import {goToUrl, toAllCasinoGame} from '@/common-pages/game-navigate';
import {NotShowAll} from '@/const/home';
import {GameCard} from './game-card';
// 1. 抽取常量
const SLIDE_WIDTHS = {
  PROMOTION: 0.48,
  GAME: 110,
  SPORTS: '19rem',
};

const RightContent = ({floor}: {floor: HomeGameFloorItem}) => {
  if (NotShowAll.includes(floor.uniqueKey)) {
    return null;
  }
  return (
    <div
      onClick={() => {
        if (floor.uniqueKey === 'LiveCasino') {
          return goTo('Live');
        }
        goTo('Casino', {
          categoryId: 5,
          gameType: floor.uniqueKey,
        });
      }}
      className="text-t3 text-[0.875rem]">
      All
    </div>
  );
};
// 渲染游戏区域
const RenderGameSection = ({
  floor,
  screenWidth,
}: {
  floor: HomeGameFloorItem;
  screenWidth: number;
}) => {
  if (NotShowAll.includes(floor.uniqueKey)) {
    if (floor.uniqueKey === 'QuickGame') {
      return (
        <div className="mb-3">
          <HomeCategory
            key={floor.id}
            title={floor.name}
            icon={floor.categoryPic}
            list={[{}]}
            swiperSlideWidth={SLIDE_WIDTHS.GAME}
            renderItem={() => null}
          />
          {/* <RenderGameCardSection
            floor={floor}
            screenWidth={screenWidth}
            onPress={card => {
              goToUrl(card.gameUrl);
            }}
          /> */}
          <div className="flex flex-row gap-[8px] px-2">
            {floor.gamesList?.map(_v => {
              const v = _v as HomeGameCardItem;
              return (
                <GameCard
                  key={v.id}
                  item={v}
                  screenWidth={screenWidth}
                  onPress={() => {
                    if (v.name.toLowerCase() === 'racecar') {
                      toAllCasinoGame(v.id);
                    } else {
                      goToUrl(v.gameUrl);
                    }
                  }}
                />
              );
            })}
          </div>
          <div className="px-2 mt-2">
            <div
              className="w-full h-[9.75rem] bg-full bg-no-repeat rounded-lg"
              onClick={() => {
                goTo('Scratch', {
                  hideInnerTitle: 1,
                });
              }}
              style={{
                backgroundImage: `url(${require('@/assets/imgs/home/scratch-off.webp')})`,
              }}
            />
          </div>
        </div>
      );
    }
    return (
      <div className="mb-3">
        <HomeCategory
          key={floor.id}
          title={floor.name}
          icon={floor.categoryPic}
          list={[{}]}
          swiperSlideWidth={SLIDE_WIDTHS.GAME}
          renderItem={() => null}
        />
        <RenderGameCardSection
          floor={floor}
          screenWidth={screenWidth}
          onPress={card => {
            if (floor.uniqueKey === 'QuickGame') {
              return goToUrl(card.gameUrl);
            }
            toAllCasinoGame(card.id);
          }}
        />
        {/* <HomeCategory
          key={floor.id}
          title={floor.name}
          icon={floor.categoryPic}
          list={floor.gamesList || []}
          swiperSlideWidth={SLIDE_WIDTHS.GAME}
          renderItem={card => (
            <GameCard
              key={card.id}
              item={card}
              screenWidth={screenWidth}
              onPress={() => {
                if (floor.uniqueKey === 'QuickGame') {
                  return goToUrl(card.gameUrl);
                }
                toAllCasinoGame(card.id);
              }}
            />
          )}
        /> */}
      </div>
    );
  }
  return (
    <div className="mb-3">
      <HomeCategory
        key={floor.id}
        title={floor.name}
        icon={floor.categoryPic}
        list={[{}]}
        swiperSlideWidth={SLIDE_WIDTHS.GAME}
        rightContent={<RightContent floor={floor} />}
        renderItem={() => null}
        // renderItem={card => (
        //   <GameCard
        //     key={card.id}
        //     item={card}
        //     screenWidth={screenWidth}
        //     onPress={() => {
        //       if (floor.uniqueKey === 'QuickGame') {
        //         return goToUrl(card.gameUrl);
        //       }
        //       toAllCasinoGame(card.id);
        //     }}
        //   />
        // )}
      />
      <RenderGameCardSection
        floor={floor}
        screenWidth={screenWidth}
        onPress={card => {
          if (floor.uniqueKey === 'QuickGame') {
            return goToUrl(card.gameUrl);
          }
          toAllCasinoGame(card.id);
        }}
      />
    </div>
  );
};

export default RenderGameSection;
